export default "__VITE_ASSET__CZfolf2Q__"